
import { defineComponent } from 'vue'
import Avatar from '@/components/Avatar.vue'
import { MemberType } from '@/types/entities'

export default defineComponent({
  props: {
    boardMembers: {
      type: Array as () => Array<MemberType>,
      required: true
    },
    taskMembers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      search: ''
    }
  },
  methods: {
    handleMemberClick (member: MemberType) {
      if (this.isTaskMember(member._id)) this.$emit('removeMember', member)
      else this.$emit('addMember', member)
    },
    isTaskMember (id: string): boolean {
      return this.taskMembers.includes(id)
    },
    sliceMail (email: string): string {
      return email.slice(0, email.indexOf('@'))
    }
  },
  components: {
    Avatar
  },
  computed: {
    searchedBoardMembers () {
      if (this.search.length) {
        return this.boardMembers.filter((member: MemberType) => member.name.indexOf(this.search) >= 0)
      }
      return this.boardMembers
    }
  }
})
